import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderSelectField} from "./inputs/SelectField";

const statuses = [
    {id: 1, name: '未対応'},
    {id: 2, name: '適正'},
    {id: 3, name: '不適正'},
];

export class RegulationResultForm extends React.Component {

    render() {

        const {handleSubmit, errors} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Field name="status"
                       label="ステータス"
                       err={errors.status}
                       data={statuses}
                       component={renderSelectField}
                       type="text"/>

            </form>
        )
    }
}

RegulationResultForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

RegulationResultForm = reduxForm({
    form: 'regulation_result'
})(RegulationResultForm);


// WEBPACK FOOTER //
// ./src/forms/regulation_result.js